// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.properties.addresses.RentalManagerPropertyAddressDetailsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { PropertyAddressDetailsWebResponseDto } from '../..';

interface DetailsParams {
  city?: string;
  fullAddress?: string;
  state?: string;
  street?: string;
  unit?: string;
  zip?: string;
}

export const RentalManagerPropertyAddressDetailsWebApiHandler_details_Path = '/api/web/v1/properties/addresses/details';

/**
 * Get property details for non authenticated users
 */
export const RentalManagerPropertyAddressDetailsWebApiHandler_details = (
  getParams: DetailsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<DetailsParams, never, PropertyAddressDetailsWebResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerPropertyAddressDetailsWebApiHandler_details_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
